import React from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { SmartCollectRefundForm } from '../Forms';
import { Text1 } from '../../../styles';


const SmartCollectRefundModal = (props) => {
    const renderTitle = () => {
        return (
            <Text1 className="d-block mb-4" strong>
                Raise Refund
            </Text1>
        )
    };

    return (
        <EaseModal
            width={350}
            title={false}
            visible={props.visible}
            onCancel={props.toggleSmartCollectRefundModal}
            centered
            hideFooter
            destroyOnClose
        >
            {renderTitle()}
            <SmartCollectRefundForm
                onSubmit={props.onSubmit}
                loading={props.loading}
                transaction={props.transaction}
            />
        </EaseModal>
    )
};

export { SmartCollectRefundModal };